import PageHeading from "Layout/AppMain/PageHeading";
import React, { useEffect, useState, useCallback } from "react";
import { Col, Row, Card, CardBody, Table, CardFooter, Button } from "reactstrap";
import { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { ReactComponent as Arrow } from "../../../../../assets/utils/images/svgs/Arrow 3.svg";
import Loader from "react-loaders";
import moment from "moment";
import TextLimit from "Api/TextLimit";
import { useNavigate } from 'react-router-dom';
import AddressVerificationModal from "Components/Modal/AddressVerificationModal";
import { BsCheckCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
registerLocale("nl", nl);

const SummaryList = ({ setStep, summary, saveTravelcostData, shiftListLoading, formDataState, selectedTravel, getTravelCostSummary, getSubstitutorShifts, getSubstitutorList,count, setSubstitutorssData }) => {
    const [dayTypes, selectedDayTypes] = useState();
    const [editModal, setEditModal] = useState(false);
    const [addressData, setAddressData] = useState(null);
    const [selectedSchoolId, setSelectedSchoolId] = useState(null);
    const [modalMessage, setModalMessage] = useState("");
    const [modalMessageType, setModalMessageType] = useState("");
    const [validationError, setValidationError] = useState("");
    const [apiError, setApiError] = useState("");
    const [formattedAddress, setFormattedAddress] = useState("");
    const [validatedAddressData, setValidatedAddressData] = useState(null);
    const [validationMessage, setValidationMessage] = useState("");
    const [validationMessageType, setValidationMessageType] = useState("");
    const [addressConfirmed, setAddressConfirmed] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isCalculating, setIsCalculating] = useState(false);


    const navigate = useNavigate();

    useEffect(() => {
        extractIdsWithValueOne(selectedTravel)
    }, [])



    function extractIdsWithValueOne(selectedTravel) {
        const idsWithValueOne = [];
        selectedTravel.forEach(obj => {
            if (obj.value === 1) {
                idsWithValueOne.push(obj.name);
            }
        });
        selectedDayTypes(idsWithValueOne)
    }

    const columns = [
        {
            header: () => 'Vervanger',
            accessorKey: 'name',
            cell: (value) => <div>
                {window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
                    : TextLimit.AfwezigeLimitOptionTwo(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)}
            </div>,
        },
        {
            header: () => 'Woonplaats',
            accessorKey: 'vCity',
            cell: (value) => <div>{value.row.original.vCity}</div>,
        },
        {
            header: () => 'E-mail (privé)',
            accessorKey: 'vEmail',
            cell: (value) => <div>{value.row.original.vEmail}</div>,
        },

        {
            header: () => 'CT',
            accessorKey: 'CT',
            cell: (value) => <div>{value.row.original.CT}</div>,
        },
        {
            header: () => 'Adresvalidatie',
            accessorKey: 'bIsAddressVerified',
            cell: ({ row }) => {
                const isVerified = row.original.bIsAddressVerified == 1;

                const handleOpenModal = () => {
                    setAddressData(row.original);
                    setSelectedSchoolId(row.original.iSchoolId);
                    setModalMessage("");
                    setModalMessageType("");
                    setValidationError("");
                    setApiError("");
                    setFormattedAddress("");
                    if (row.original.bIsAddressVerified == 1) {
                        setValidatedAddressData({
                            verified: 1,
                            tAddress: row.original.tAddress,
                            vPostCode: row.original.vPostCode,
                            vCity: row.original.vCity,
                            vCountry: row.original.vCountry,
                        });
                    } else {
                        setValidatedAddressData(null);
                    }

                    setEditModal(true);
                    setValidationMessage('');
                    setValidationError('');
                    setAddressConfirmed(false);
                };

                return (
                    <span
                        className="ms-3 d-flex justify-content-start align-items-center"
                        style={{ cursor: 'pointer' }}
                        onClick={handleOpenModal}
                    >
                        {isVerified ? (
                            <BsCheckCircle color='#39A825' fontSize={"14px"} />
                        ) : (
                            <span style={{ display: 'inline-flex', pointerEvents: 'all' }}>
                                <CrossIcon color='#FB2E5F' />
                            </span>
                        )}
                    </span>
                );
            },

        },

    ];

    const goToLastStep = () => {
        setStep('step2')
    }

    const handleSubmit = async () => {
        if (formDataState.automatic == 1) {
            setSubstitutorssData([])
            const response = await saveTravelcostData();
            if (response?.status === true) {
                navigate("/reiskosten/overzicht");
            }
        }
        else {
            if (formDataState.substitutorList.length == 0) {
                setSubstitutorssData([])
                saveTravelcostData();
            }
            else {
                setStep('step4');
                getSubstitutorShifts(0)
            }
        }
    }

    return (
        <div>
            <Row>
                <Col md="10" lg="10">
                    <PageHeading />
                </Col>
            </Row>
            {(shiftListLoading || (!summary || summary.length === 0)) ? (
                <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
            )
                :
                (
                    <>
                        <Row>
                            <Col md="12" lg="12" >
                                <Card className="main-card mb-3 sub-detail-table-style">
                                    <CardBody className="p-3">
                                        <div className="btn-color-style travelCost-blue-text mb-2 ms-1">
                                            Instellingen deze reiskostenberekening
                                        </div>
                                        <Table size="sm" borderless className="mb-0 ">
                                            <tbody>
                                                <tr className="border-bottom-0">
                                                    <th className="fw-bold col-2">Bestuur</th>
                                                    <th className="fw-bold col-2">Periode</th>
                                                    <th className="fw-bold col-2">Dagtypen </th>
                                                    <th className="fw-bold col-2">Informeren vervanger</th>
                                                </tr>
                                                <tr className="border-bottom-0">
                                                    <td className="wl">
                                                        {formDataState.travelData.communityData.vCommunityName}
                                                    </td>

                                                    <td className="wl">
                                                        {moment(formDataState.startDate, 'YYYY-MM-DD').format('DD-MM-YY') + " tot " + moment(formDataState.endDate, 'YYYY-MM-DD').format('DD-MM-YY')}
                                                    </td>

                                                    <td className="wl">
                                                        {dayTypes && dayTypes.join(', ')}
                                                    </td>

                                                    <td className="wl">
                                                        {(formDataState.email == 1) && "E-mail"} {((formDataState.email == 1) && (formDataState.pdf == 1)) && ","} {(formDataState.pdf == 1) && "PDF in Clooser.nl"}
                                                    </td>
                                                </tr>

                                                <tr className="border-bottom-0">
                                                    <td className="p-0" colSpan="5">
                                                        <Table size="sm" borderless className="mb-0 verzoeken-inner-table">
                                                            <tbody>
                                                                <tr className="border-bottom-0">
                                                                    <th className="fw-bold col-2">Vergoeding per km afstand</th>
                                                                    <th className="fw-bold col-2">Aftrek aantal km</th>
                                                                    <th className="fw-bold col-2">Maximumbedrag per dag</th>
                                                                    <th className="fw-bold col-2">Werkwijze</th>
                                                                </tr>
                                                                <tr className="border-bottom-0">
                                                                    <td className="wl">
                                                                        € {(formDataState.vPrice).replace('.', ',')}
                                                                    </td>

                                                                    <td className="wl">
                                                                        {Number(formDataState.vKm)}
                                                                    </td>

                                                                    <td className="wl">
                                                                        € {Number(String(formDataState.vBedrag || "0").replace(',', '.'))
                                                                            .toFixed(2)
                                                                            .replace('.', ',')}
                                                                    </td>



                                                                    <td className="wl">
                                                                        {(formDataState.automatic == 1) ? "Alle automatisch verwerken" : "Per vervanger verwerken"}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </Table>

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" lg="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3 table-responsive">
                                        <ReactTableGeneric
                                            data={summary.summaryList}
                                            columns={columns}
                                            tableClassName="mb-0 table table-sm table-hover table-borderless"
                                            filters={{ search: false, pagination: true, sorting: false }}
                                            count={count}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )
            }
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex justify-content-end w-100">
                        <Button
                            outline
                            className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn me-2"
                            onClick={handleSubmit}
                            type="button"
                            color="primary"
                        >
                            Verwerken
                        </Button>
                        <Button size="sm" outline className="me-2 btn-color-style footer-btn-styling py-1" color="primary">
                            <Arrow onClick={goToLastStep} />
                        </Button>
                    </div>
                </CardFooter>
            </div>
            <AddressVerificationModal
                isOpen={editModal}
                toggle={() => setEditModal(false)}
                addressData={addressData}
                validatedAddressData={validatedAddressData}
                modalMessage={modalMessage}
                setModalMessage={setModalMessage}
                modalMessageType={modalMessageType}
                setModalMessageType={setModalMessageType}
                validationMessage={validationMessage}
                setValidationMessage={setValidationMessage}
                validationMessageType={validationMessageType}
                setValidationMessageType={setValidationMessageType}
                validationError={validationError}
                setValidationError={setValidationError}
                formattedAddress={formattedAddress}
                setFormattedAddress={setFormattedAddress}
                addressConfirmed={addressConfirmed}
                setAddressConfirmed={setAddressConfirmed}
                isValidating={isValidating}
                setIsValidating={setIsValidating}
                isValidated={isValidated}
                setIsValidated={setIsValidated}
                isSaving={isSaving}
                setIsSaving={setIsSaving}
                isCalculating={isCalculating}
                setIsCalculating={setIsCalculating}
                selectedSchoolId={selectedSchoolId}
                setSelectedSchoolId={setSelectedSchoolId}
                CrossIcon={CrossIcon}
                formDataState={formDataState}
                getSubstitutorList={getTravelCostSummary}
                apiAfterConfirm={async () => {
                    await getTravelCostSummary();
                }}
            />



        </div>

    )

};

export default SummaryList;
